import { render, staticRenderFns } from "./PrivateChat.vue?vue&type=template&id=02e04337&scoped=true"
import script from "./PrivateChat.vue?vue&type=script&lang=js"
export * from "./PrivateChat.vue?vue&type=script&lang=js"
import style0 from "./PrivateChat.vue?vue&type=style&index=0&id=02e04337&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e04337",
  null
  
)

export default component.exports